module.exports = __webpack_public_path__ + "static/img/dateChoose.bd8c54cb.svg";